
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!paginated_view";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/bitrock/ruby27stack/apps/canvaslms/htdocs/ui/shared/pagination/jst/PaginatedView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"paginatedView-loading\" role=\"alert\" aria-live=\"assertive\">\n    <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("paginated_view")
  },data:data},helper ? helper.call(depth0, "loading_more_results", "Loading more results", options) : helperMissing.call(depth0, "t", "loading_more_results", "Loading more results", options)))
    + "</span>\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';
    brandableCss.loadStylesheet('jst/PaginatedView', {"new_styles_normal_contrast":{"combinedChecksum":"bf30c3a7d1"},"new_styles_high_contrast":{"combinedChecksum":"bf30c3a7d1"},"responsive_layout_normal_contrast":{"combinedChecksum":"bf30c3a7d1"},"responsive_layout_high_contrast":{"combinedChecksum":"bf30c3a7d1"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"bf30c3a7d1"},"new_styles_high_contrast_rtl":{"combinedChecksum":"bf30c3a7d1"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"bf30c3a7d1"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"bf30c3a7d1"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  